import * as React from "react";

function Blueprint(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M12.0432 1.21881C12.3555 1.21817 12.6567 1.21756 12.9356 1.33309C13.2145 1.44862 13.427 1.662 13.6474 1.8833L13.6968 1.93283L17.2859 5.52194L17.3355 5.57134C17.5568 5.79173 17.7701 6.00424 17.8857 6.28316C18.0012 6.56208 18.0006 6.86322 17.9999 7.17555L17.9998 7.2455V14.9465C17.9999 15.7961 17.9999 16.4904 17.9262 17.0386C17.8492 17.6115 17.6824 18.1083 17.2859 18.5048C16.8894 18.9013 16.3927 19.068 15.8197 19.1451C15.2716 19.2187 14.5773 19.2187 13.7278 19.2187H8.02219C7.17262 19.2187 6.47826 19.2187 5.93014 19.1451C5.35718 19.068 4.86044 18.9013 4.46392 18.5048C4.06741 18.1083 3.9007 17.6115 3.82366 17.0386C3.74997 16.4904 3.74998 15.7962 3.75 14.9465V5.4911C3.74998 4.64149 3.74997 3.94719 3.82366 3.39905C3.9007 2.82609 4.06741 2.32934 4.46392 1.93283C4.86044 1.53631 5.35718 1.3696 5.93014 1.29257C6.47828 1.21888 7.17257 1.21889 8.02219 1.21891H11.9733L12.0432 1.21881Z"
                stroke="#838280"
            />
            <path
                d="M11.8145 4.53124V0.781281C12.6077 0.781281 13.3662 1.10704 13.9124 1.68232L17.4394 5.39731V6.40622H13.6894C12.8056 6.40622 12.3636 6.40622 12.089 6.13164C11.8145 5.85705 11.8145 5.41511 11.8145 4.53124Z"
                fill="#838280"
            />
            <path
                d="M7.92254 10.0506L8.95995 11.3366H7.92254V12.6225V16.5878H6.20795V15.1944V12.6225V11.3366H5.2381L6.20795 10.0506L7.06525 8.84405L7.92254 10.0506Z"
                fill="#838280"
            />
            <path
                d="M12.5617 16.5865L11.2757 17.6239L11.2757 16.5865L9.9898 16.5865L7.41792 16.5865L7.41792 14.8719L9.9898 14.8719L11.2757 14.8719L11.2757 13.9021L12.5617 14.8719L13.7619 15.7292L12.5617 16.5865Z"
                fill="#838280"
            />
        </svg>
    );
}

export default Blueprint;
